import { CompartmentSelector, CompartmentSelectorIndex, Pagination, PaginationResponse } from '@ekkogmbh/apisdk';
import { ListItemText } from '@mui/material';
import React, { useCallback } from 'react';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  coordinate: string;
  selected?: CompartmentSelectorIndex;
  optional?: boolean;
  onChange: (selector: CompartmentSelector | undefined) => void;
  disabled?: boolean;
  label?: string;
}

export const CompartmentSelectorPicker = ({
  coordinate,
  selected,
  onChange,
  label,
  ...props
}: Props): React.JSX.Element => {
  const { api } = useEkko();

  const fakePaginatedFetch = useCallback(
    async (pagination: Pagination) => {
      const { page, limit } = pagination;
      const selectors = await api.getAvailableCompartmentSelectors(coordinate);

      let pageChunk: CompartmentSelector[];
      if (limit === undefined) {
        pageChunk = selectors;
      } else {
        pageChunk = selectors.slice((page - 1) * limit, limit);
      }

      return {
        pageCount: selectors.length / (limit ?? 1),
        itemsPerPage: limit,
        totalItemCount: selectors.length,
        items: pageChunk,
      } as PaginationResponse<CompartmentSelector>;
    },
    [api, coordinate],
  );

  return (
    <PaginatedSelect
      {...props}
      label={label ?? 'Compartment Selector'}
      value={selected as CompartmentSelector}
      itemId={(cs: CompartmentSelector) => cs.coordinate + '::' + cs.name}
      itemRender={(cs: CompartmentSelector) => <ListItemText primary={cs.name} secondary={cs.coordinate} />}
      fetchPaginatedItems={fakePaginatedFetch}
      onChange={(update) => onChange(update as CompartmentSelector | undefined)}
    />
  );
};
